import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { withSpinner } from '../../extensions/withSpinner.extension';
import { Notification } from '../../types';
import { API_ROOT } from '../../types/constants/appconstants';

@Injectable({
    'providedIn': 'root'
})

export class NotificationService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private notificationBaseUrl = this.apiRoot + 'api/notifications';

    getNotifications(edhMarketId: number): Observable<Notification[]> {
        return withSpinner(this.http).get<Notification[]>(`${this.notificationBaseUrl}/${edhMarketId}`);
    }

    getNotification(notificationId: number): Observable<Notification> {
        return withSpinner(this.http).get<Notification>(`${this.notificationBaseUrl}/${notificationId}`);
    }

    saveNotification(notification: Notification): Observable<Notification> {
        return withSpinner(this.http).post<Notification>(`${this.notificationBaseUrl}`, notification);
    }

    deleteNotification(notificationId: number): Observable<number> {
        return withSpinner(this.http).delete<number>(`${this.notificationBaseUrl}/${notificationId}`);
    }
}
